
import React from 'react';

const EmailInbox = () => {
  const handleClick = () => {
    window.open('https://email.autopulsecrm.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Seamless Gmail Synchronization</h2>
      <p style={styles.description}>
        Keep your emails synced across all devices with our powerful and secure Gmail synchronization tool.
        Never miss an important email again.
      </p>
      <button style={styles.button} onClick={handleClick}>
        Start Syncing Now
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '50px auto',
    textAlign: 'center',
    padding: '40px 20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
  },
  heading: {
    fontSize: '24px',
    fontWeight: '700',
    background: 'linear-gradient(to right, #00c6ff, #0072ff)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: '20px'
  },
  description: {
    fontSize: '16px',
    color: '#555',
    marginBottom: '30px'
  },
  button: {
    padding: '12px 24px',
    fontSize: '16px',
    backgroundColor: '#4285f4',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600'
  }
};

export default EmailInbox;

